import ScheduleEvaluation from 'domains/evaluations/Components/ScheduleEvaluation';
import { ScheduleContextV3, withScheduleMachineStateV3 } from 'domains/signupv3/schedule/context';
import { TimeZone } from 'domains/timezone';
import { useCallback, useEffect } from 'react';
import { ScheduleV3InternalLoadingStep } from './InternalLoaderStep';

const ScheduleWrapper = () => {
  const availableTimes = ScheduleContextV3.useSelector(({ context }) => context.data.availableEvalTimes ?? []);
  const selectedDateIndex = ScheduleContextV3.useSelector(({ context }) => context.data.selectedDateIndex);
  const currentStep = ScheduleContextV3.useSelector(state => state.value);

  const { send } = ScheduleContextV3.useActorRef();

  const onChangeDay = useCallback(
    (value: Date, index: number) => {
      if (currentStep === 'loadingAvailableEvalDates') {
        send({
          type: 'cancelLoadingAvailableEvalDates',
        });
      }

      send({
        type: 'submitSelectedDate',
        selectedDate: value,
        selectedDateIndex: index,
      });
    },
    [availableTimes, currentStep, send],
  );

  const onSubmit = useCallback(
    (value: Date, displayTimezone: TimeZone, calendarID: number, therapistName: string) => {
      send({
        type: 'submitEvaluationInfo',
        calendarID,
        evaluationDate: value,
        evaluationTimezone: displayTimezone,
        therapistName,
      });
    },
    [send],
  );

  useEffect(() => {
    send({
      type: 'initAvailableEvalTimes',
    });
  }, [send]);

  return (
    <ScheduleEvaluation
      availableTimes={availableTimes}
      selectedDateIndex={selectedDateIndex}
      onChangeDay={onChangeDay}
      onSubmit={onSubmit}
      renderLoadingComponent={props => <ScheduleV3InternalLoadingStep {...props} />}
    />
  );
};

export const ScheduleV3EnterEvaluationDate = withScheduleMachineStateV3(ScheduleWrapper, [
  'enterEvaluationDate',
  'loadingAvailableEvalDates',
  'loadingAvailableEvalDatesFailed',
]);
